import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useRef,
  useReducer
} from "react";
import {
  TextBox,
  Select,
  Checkbox,
  LogoHp,
  Table,
  Button,
  Modal,
  Card,
  InlineNotification
} from "@veneer/core";
import { Row, Col, Container } from "react-bootstrap";
import type { RootState } from '@store/store';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import Loader from "@components/home-page/shared-components/loader/loader";
import { setShippingAddressFormValidity } from '@store/reducers/form-equipment-physical-shipping-address-slice';

import { columns, EquipmentPhysicalAddress, shipingResetFileds, shipingSiteNameResetFileds } from '@constants/case-create'
import {
  getFieldError,
  getValidatedNumberInput,
  isValidAddress,
  isValidCityName,
  isValidCompanyName,
  isValidEmail,
  isValidPhoneNumber,
  isValidStateName,
  onSearchDropDown,
  scrollToErrorField,
  validateFields,
  validateName,
  isValidField,
} from "../../../../utils";
import { fetchContactDetails } from "@services/fetch-contact-details-info";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { apiPost } from "@services/service";
import { POST_validateaddress } from "services";
import { toast } from "react-toastify";
import { addressvalidatedcountryexclusionlst } from "resources/exclusion-country-validation";
import { Trans, useTranslation } from 'react-i18next';
import { setLoading } from "@store/reducers/loadingSlice";
import { POST_SHIPPING_ADDRESS_CHANGE } from "@constants/end-points";
import { updateBindPin } from "@store/reducers/create-case-apis";
import { HpLogo } from "@components/home-page/shared-components/hp-logo/hp-logo";
import CustomTable from "@components/shared-components/custom-table/custom-table";
import "./equipment-physical-address-fields.css";
interface PhysicalAddressFieldsProps {
  headerTitle?: string;
  headerContent?: string;
  checkBoxContent?: string;
  onValidationChange?: (isValidated: boolean, contryEnable: boolean) => void;
  onNewEquipmentContactChange?: (isNew: boolean) => void;
}

export interface PhysicalAddressFieldsRef {
  submitForm: () => boolean;
}

type equipmentPhysicalAddress = typeof EquipmentPhysicalAddress;

const PhysicalAddressFields = forwardRef<PhysicalAddressFieldsRef, PhysicalAddressFieldsProps>(
  ({ headerTitle, headerContent, checkBoxContent, onValidationChange, onNewEquipmentContactChange }, ref) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch()
    const { savedContactsDropDown, countryList, countryCodes, siteSubAccount, bindPin, IsTaxEnabledCountry } = useAppSelector((state: RootState) => state.createCaseAPI);

    const [popupTilte, setPopupTitle] = useState<string>("");
    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const formShippingAddressData = useAppSelector((state) => state.formShippingAddressInfo.formShippingAddressData);
    const [formDetails, setFormDetails] = useState<equipmentPhysicalAddress>(formShippingAddressData);
    const [errors, setErrors] = useState<equipmentPhysicalAddress>(EquipmentPhysicalAddress);
    const [formTouched, setFormTouched] = useState(false);

    const [filteredCountryCodes, setFilteredCountryCodes] = useState(countryCodes || []);
    const [filteredCountryList, setFilteredCountryList] = useState(countryList || []);
    const [loaderBtn, setLoaderBtn] = useState(false);
    const [siteNameList, setSiteNameList] = useState(siteSubAccount || []);
    const [bindPinList, setBindPinList] = useState(bindPin || []);
    const [filteredAltContacts, setFilteredAltContacts] = useState();
    const [isValidateAddressClicked, setIsValidateAddressClicked] = useState(false);
    const [isAddressValidated, setIsAddressValidated] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedAddressRow, setSelectedAddressRow] = useState<any>(null);
    const [isRowSelected, setIsRowSelected] = useState(false);
    const [acceptedSnapshot, setAcceptedSnapshot] = useState<any>(null);
    const [isAcceptFlow, setIsAcceptFlow] = useState(false);
    const [contryEnable, setContryEnable] = useState<boolean>(false);
    const PAGE_SIZE = 10;
    const headerTitle2 = t('HPI.CreateCase.Tabs.EquipmentAddress', {
      defaultValue: `Equipment Address`
    });
    useEffect(() => {
      if (onValidationChange) {
        onValidationChange(isAddressValidated, contryEnable);
      }
    }, [isAddressValidated, contryEnable, onValidationChange]);
    useEffect(() => {

      if (savedContactsDropDown.length) {
        let savedContacts: any = [
          { label: t('HPI.Dropdown.SelectSavedContact', { defaultValue: 'create a new contact' }), value: "-1" },
          ...savedContactsDropDown
        ];
        setFilteredAltContacts(savedContacts);
      }
      const isExcluded = addressvalidatedcountryexclusionlst.some(
        (country: any) =>
        country.toLowerCase() === formDetails?.countryName?.toLowerCase()
       );

      setFormDetails((prevData) => ({
      ...prevData,
      validatedAddress: "off",
      EquipmentCountryName: formDetails?.countryName,
      }));

      setContryEnable(isExcluded);
      setIsAddressValidated(false);
//       if (addressvalidatedcountryexclusionlst.some((country: any) => country.toLowerCase() === formDetails?.EquipmentCountryName.toLowerCase())) {
//         setContryEnable(true)
//         setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "on" }))
//         setIsValidateAddressClicked(false);

// ;      }
    }, []);

    useEffect(() => {
      setBindPinList(bindPin);
      if (bindPin.length === 1) {
        setFormDetails((prevData) => ({ ...prevData, ['BindingPin']: [bindPin[0].value] }));
      }
    }, [bindPin]);


    const defaultRequiredFields = [
      'FirstName', 'LastName','contactCountryId', 'countryId', 'PhoneNumber', 'Email',
      'company', 'SiteName', 'AddressLine1', 'City', 'State',
      'ZipCode'
      //  'country'
      ];

    const additionalFields = ['equipmentTaxId', 'equipmentTaxOfficeName'];
    const bindingPin = ['BindingPin'];
    const isSingleUserRole = ['company', 'SiteName'];

    const requiredFieldsRef = useRef<string[]>(defaultRequiredFields);

    const [, forceUpdate] = useReducer(x => x + 1, 0);

    const updateRequiredFields = (updater: (prev: string[]) => string[]) => {
      requiredFieldsRef.current = updater(requiredFieldsRef.current);
      forceUpdate();
    };
    
    const [disableValidate, setDisableValidate] = useState<boolean>(true);
    const [modalAddress, setModalAddress] = React.useState<any>([]);
    const showValidateWarning =
    contryEnable || formDetails.validatedAddress === "on";
    const validateForm = (formDetails: equipmentPhysicalAddress) => {
      let formIsValid = true;
      let firstErrorField: string | null = null;
      for (const key in formDetails) {
        if (formDetails.hasOwnProperty(key)) {
          const value = formDetails[key as keyof equipmentPhysicalAddress];
          const valueToValidate = Array.isArray(value) ? value.join(' ') : value;
          const error = validateFields(key, valueToValidate, requiredFieldsRef.current, t);
          if (error) {
            setErrors((prevState) => ({
              ...prevState,
              [key]: error,
            }));
            formIsValid = false;
            if (!firstErrorField) {
              firstErrorField = key;
            }
          } else {
            if (Array.isArray(formDetails[key as keyof equipmentPhysicalAddress])) {
              setErrors((prevState) => ({
                ...prevState,
                [key]: [''],
              }));
            } else {
              setErrors((prevState) => ({
                ...prevState,
                [key]: '',
              }));
            }
          }
        }
      }
      if (!formIsValid && firstErrorField) {
        scrollToErrorField(firstErrorField)
      }
      return formIsValid;
    };
    // useEffect(() => {
    //   // If contryEnable is true, make validateBtn a required field
    //   if (contryEnable) {
    //     if (!requiredFieldsRef.current.includes('validateBtn')) {
    //       requiredFieldsRef.current.push('validateBtn');
    //     }
    //   } else {
    //     // Remove validateBtn from required fields
    //     requiredFieldsRef.current = requiredFieldsRef.current.filter(
    //       (field) => field !== 'validateBtn'
    //     );
    //   }
    // }, [contryEnable]);
    useEffect(() => {
      setFormDetails(formShippingAddressData)
      if (formShippingAddressData?.showparts === '100000001') {
        updateRequiredFields(prevFields => prevFields.filter(field => !additionalFields.includes(field)));
      } else {
        if (IsTaxEnabledCountry.includes(formDetails?.countryId[0])) {
          updateRequiredFields(prevFields => Array.from(new Set([...prevFields, ...additionalFields])));
        }
      }
    }, [formShippingAddressData?.showparts]);

    useEffect(() => {
      if (window.IsIndividualRole) {
        updateRequiredFields(prevFields => prevFields.filter(field => !isSingleUserRole.includes(field)));
      }
    }, []);

    useEffect(() => {
      if (formShippingAddressData?.SiteName && bindPin.length > 0) {
        updateRequiredFields(prevFields => Array.from(new Set([...prevFields, ...bindingPin])));
      } else {
        updateRequiredFields(prevFields => prevFields.filter(field => !bindingPin.includes(field)));

      }
    }, [bindPin || formShippingAddressData?.SiteName])

    useEffect(() => {
      if (formDetails.AddressLine1.length && formDetails.City.length && formDetails.State.length && formDetails.ZipCode.length && formDetails.countryId[0] !== '') {
        setDisableValidate(false)
      } else {
        setDisableValidate(true)
      }
      if (formTouched) {
        const isValid = false;
        dispatch(setShippingAddressFormValidity({
          isValid,
          formData: formDetails
        }));
      }

    }, [formDetails]);
    useEffect(() => {
      if (!acceptedSnapshot) return;
      if (isAcceptFlow) return;
      setIsAddressValidated(false);

      const isDirty =
        acceptedSnapshot.AddressLine1 !== formDetails.AddressLine1 ||
        acceptedSnapshot.City !== formDetails.City ||
        acceptedSnapshot.State !== formDetails.State ||
        acceptedSnapshot.ZipCode !== formDetails.ZipCode ||
        acceptedSnapshot.countryId !== formDetails.countryId[0];

      if (isDirty) {
        setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "on" }))
      }
    }, [
      formDetails.AddressLine1,
      formDetails.City,
      formDetails.State,
      formDetails.ZipCode,
      formDetails.countryId,
    ]);

    useImperativeHandle(ref, () => ({
      submitForm: () => {
        const isValid = validateForm(formDetails);
    if (contryEnable && !isAddressValidated) {
      toast.error("Please validate address before submitting");
      return false;
    }
        if (isValid) {
          dispatch(setShippingAddressFormValidity({ isValid, formData: formDetails }));
        }
        return isValid;
      }
    }));

    const fetchContactInfo = useCallback(async (payload: any) => {
      try {
        const data = await fetchContactDetails(dispatch, payload);
        setFormDetails((prevData) => ({ ...prevData,
          FirstName: data.FirstName,
          LastName: data.LastName,
          Email: data.Email,
          PhoneNumber: data.PhoneNumber,
          AlternatePhoneNumber: data.AlternatePhoneNumber,
          // UserId: prevData.UserId,
          contactCountryId: data.countryId,
          
          })); 
        // const isExcluded =
        //   !!data?.countryName &&
        //   addressvalidatedcountryexclusionlst.some(
        //     (country: any) =>
        //       country.toLowerCase() === data?.countryName.toLowerCase()
        //   );
        //   if (isExcluded){
        //   setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "on" }));
        // }else{
        //   setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "off" }));
        // }
        // setFormDetails((prevData) => ({ ...prevData, ['EquipmentCountryName']: data?.countryName }));

        // setContryEnable(isExcluded);  
      } catch (err) {
        setContryEnable(false)
        // setError("Failed to load contact details");
      }
    }, []);

    const fetchSiteNameInfo = useCallback(async (payload: any) => {
      try {
        dispatch(setLoading(true));
        const response = await apiPost(POST_SHIPPING_ADDRESS_CHANGE, payload);
        const addressdata = JSON.parse(response?.data?.addressdata || '[]')[0] || {};
        const newBindPinData = JSON.parse(response?.data?.bindPinList || '[]') || []; // Prevent errors if response is empty
        const isExcluded =
          !!addressdata?.countryName &&
          addressvalidatedcountryexclusionlst.some(
            (country: any) =>
              country.toLowerCase() === addressdata.countryName.toLowerCase()
          );
          if (isExcluded){
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "on" }));
        }else{
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "off" }));
        }
        setFormDetails((prevData) => ({ ...prevData, ['EquipmentCountryName']: addressdata?.countryName }));

        setContryEnable(isExcluded);  
        dispatch(updateBindPin(newBindPinData));

        setFormDetails((prevData) => ({
          ...prevData,
          AddressLine1: addressdata.AddressLine1 || '',
          AddressLine2: addressdata.AddressLine2 || '',
          AddressLine3: addressdata.AddressLine3 || '',
          City: addressdata.City || '',
          Mailstop: addressdata.Mailstop || '',
          State: addressdata.State || '',
          ZipCode: addressdata.ZipCode || '',
          company: addressdata.company || '',
          contactphone: addressdata.contactphone || '',
          country: [addressdata?.country],
          countryId: [addressdata?.country],
          fullname: addressdata.fullname || '',
        }));

        dispatch(setLoading(false));
      } catch (error: any) {
        dispatch(setLoading(false));
        throw new Error(error.message || "Failed to fetch contact details");
      }
    }, []);

    const onSiteNameCleareHandler = () => {
      const selectedCountry = formDetails.country[0];   
      setFormDetails((prevData) => ({ ...prevData, ...shipingSiteNameResetFileds, 
        country: [selectedCountry], 
        countryId: [''], 
        EquipmentCountryName: "", 
      }));
      setContryEnable(false)
    }

    const selectSavedClearHandler = () => {
      setFormDetails((prevData) => ({ ...prevData, ...shipingResetFileds }));
    }

    const selectPinClearHandler = () => {
      setFormDetails((prevData) => ({ ...prevData, ['BindingPin']: [''] }));
    }

    const popupHeader = () => {
      return (
        <p className="popup-header">
          <img
            src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
            alt=""
            style={{ height: "46px", width: "auto" }}
          />
          <span>{popupTilte}</span>
        </p>
      );
    };

    const handleCallBack = (title: string) => {
      setPopupTitle(title);
      setIsOpen(true);
    }
   const handleAddressRowSelect = (rowData: any) => {
     setSelectedAddressRow(rowData);
     setIsRowSelected(true);
   };
    const handleAcceptAddress = () => {
  if (!selectedAddressRow) return;

  setIsAcceptFlow(true);
  const acceptedData = {
    AddressLine1: selectedAddressRow.AddressLine1,
    AddressLine2: selectedAddressRow.AddressLine2,
    City: selectedAddressRow.City,
    State: selectedAddressRow.Province,
    ZipCode: selectedAddressRow.PostalCode,
    countryId: [...formDetails.countryId],
  };

  setAcceptedSnapshot({
    ...acceptedData,
    countryId: formDetails.countryId[0],
  });

  setFormDetails((prev) => ({
    ...prev,
    ...acceptedData,
    validatedAddress: "off",
  }));

  setOpen(false);
  setIsRowSelected(false);
  setSelectedAddressRow(null);

  setTimeout(() => setIsAcceptFlow(false), 0);
    };
const handleRetainClicked = () => {
  setIsAcceptFlow(true);

  const snapshot = {
    AddressLine1: formDetails.AddressLine1,
    AddressLine2: formDetails.AddressLine2,
    City: formDetails.City,
    State: formDetails.State,
    ZipCode: formDetails.ZipCode,
    countryId: formDetails.countryId[0],
  };

  setAcceptedSnapshot(snapshot);

  setFormDetails((prev) => ({
    ...prev,
    validatedAddress: "off",
  }));

  setOpen(false);

  // allow state updates 
  setTimeout(() => setIsAcceptFlow(false), 0);
};

    const onSelectChangeHandler = (selectedOption: any, k: any) => {
      setErrors(EquipmentPhysicalAddress);
      if (k === 'UserId' || k === 'countryId') {
        // setFormDetails((prevData) => ({ ...prevData, validateBtn: '' }));
        setIsValidateAddressClicked(false);
        setIsAddressValidated(false);
      }
      if (selectedOption?.value !== '-1') {
        setFormTouched(true)
        setFormDetails((prevData) => ({
          ...prevData,
          [k]: [selectedOption?.value],
          ...(k === "UserId" ? { isEquipmentContactSelected: true, NewEquipmentContact: false } : {}),
        }));
        if (k === "UserId") onNewEquipmentContactChange?.(false);
        // if (k === 'country' && selectedOption.value !== '-1') {
        // setFormDetails((prevData) => ({ ...prevData, ['EquipmentCountryName']: selectedOption?.label }));

        //   const isExcluded = addressvalidatedcountryexclusionlst.some((country: any) => country.toLowerCase() === selectedOption.label.toLowerCase());
        //   setContryEnable(isExcluded);
        // }
      } else {
        selectSavedClearHandler();
        setFormTouched(true);
        setFormDetails((prevData) => ({
          ...prevData,
          [k]: ['-1'],
          ...(k === "UserId" ? { isEquipmentContactSelected: false, NewEquipmentContact: true } : {}),
        }));
        if (k === "UserId") onNewEquipmentContactChange?.(true);
      }

      if (k === 'UserId' && selectedOption.value !== '-1') {
        const payload = {
          contactid: selectedOption.value,
        };

        fetchContactInfo(payload);

      }

      if (k === 'countryId' && selectedOption.value !== '-1') {
        setFormDetails((prevData) => ({ ...prevData, ['EquipmentCountryName']: selectedOption?.label }));
        const isExcluded = addressvalidatedcountryexclusionlst.some((country: any) => country.toLowerCase() === selectedOption.label.toLowerCase() || country.toLowerCase() === selectedOption.CountryName.toLowerCase());
       if (isExcluded){
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "on" }));
        }else{
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddress']: "off" }));

        }
        setContryEnable(isExcluded);

        if (IsTaxEnabledCountry.includes(selectedOption.value)) {
          updateRequiredFields(prevFields => Array.from(new Set([...prevFields, ...additionalFields])));
          setFormDetails((prevData) => ({ ...prevData, ['equipmentCountry']: selectedOption.label }));
        } else {
          updateRequiredFields(prevFields => prevFields.filter(field => !additionalFields.includes(field)));
          setFormDetails((prevData) => ({ ...prevData, ['equipmentCountry']: '' }));
          setFormDetails((prevData) => ({ ...prevData, ['equipmentTaxId']: '' }));
          setFormDetails((prevData) => ({ ...prevData, ['equipmentTaxOfficeName']: '' }));
        }

      }

      if (k === 'SiteName') {
        const payload = {
          accountid: selectedOption.value,
        };
        fetchSiteNameInfo(payload);
      }
      validateField(k, selectedOption?.value)
    }

    const onSiteChangeHandler = (selectedOption: any) => {
      if (!formTouched) setFormTouched(true);
      const siteName = siteNameList.map((items: any) => {
        if (items.value === selectedOption?.value) {
          return items.
            label;
        }
      }).filter(Boolean)[0];

      setFormDetails((prevData) => ({ ...prevData, ['company']: siteName }));
    }

    const handleInputChange = (v: any, event: React.ChangeEvent<HTMLInputElement>) => {
      if (!formTouched) setFormTouched(true);
      const { name, value } = event.target;
      setFormDetails((prevData) => ({ ...prevData, [name]: v }));

      if (['PhoneNumber', 'Email'].includes(name)) {
        setErrors((prevState) => ({
          ...prevState,
          [name]: '',
        }));
      } else {
        validateField(name, v);
      }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      if (value) {
        validateField(name, value);
      }
    };
    // Pagination logic for Validate address Popup
const pagedData = modalAddress.slice(
  (currentPage - 1) * PAGE_SIZE,
  currentPage * PAGE_SIZE
);
  
  const handlePageChange = (direction: 'prev' | 'next') => {
  setCurrentPage((prevPage) => {
    if (direction === 'prev' && prevPage > 1) {
      return prevPage - 1;
    }
    if (direction === 'next' && currentPage * PAGE_SIZE < modalAddress.length) {
      return prevPage + 1;
    }
    return prevPage;
  });
};
// Render the pagination buttons only if necessary
const totalPages = Math.ceil(modalAddress.length / PAGE_SIZE);

  

    const validateField = (name: string, value: string) => {
      const validators: { [key: string]: { fn: (val: string) => boolean; msg: string } } = {
        // FirstName: { fn: !isValidField, msg: t('HPI.ErrorMessage.InvalidFirstName',{defaultValue:'Invalid First Name'}) },
        // LastName: { fn: isValidField, msg: "Invalid Last Name" },
        Email: { fn: isValidEmail, msg: t('HPI.ErrorMessage.InvalidEmailFormat', { defaultValue: 'Invalid email format' }) },
        PhoneNumber: { fn: isValidPhoneNumber, msg: t('HPI.ErrorMessage.InvalidNumber', { defaultValue: 'Phone number must be 8-15 digits long and contain only numbers.' }) },
        // AddressLine1: { fn: isValidField, msg: "Please add a valid Address" },
        // AddressLine2: { fn: isValidField, msg: "Please add a valid Address" },
        // City: { fn: isValidField, msg: "Please add a valid city name." },
        // State: { fn: isValidField, msg: "Please add a valid state name" },
        // company: { fn: isValidField, msg: "Please add a valid company name" },
      };

      let error = "";
      // Skip validation for validateBtn if it's clicked
      // if (name === 'validateBtn' && isValidateAddressClicked) {
      //   setErrors((prevState) => ({
      //     ...prevState,
      //     [name]: "", // No error for validateBtn once clicked
      //   }));
      //   return;
      // }

      // // Skip validation for validateBtn if it's not enabled
      // if (name === 'validateBtn' && !contryEnable) {
      //   return;
      // }
      if (!value) {
        error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' });
      } else if (validators[name] && !validators[name].fn(value)) {
        error = validators[name].msg;
      }

      setErrors((prevState) => ({
        ...prevState,
        [name]: error,
      }));
    };

    const clearSelectHandler = (field: any) => {
      setFormDetails((prevData) => ({ ...prevData, [field]: [''],
         ...(field === "countryId"
      ? {
          EquipmentCountryName: "",
          validatedAddress: "off",
        }
      : {}),
       }));
        if (field === "countryId") {
    setContryEnable(false);
  }
      validateField(field, '')
      
    }

    const onAcknowledgeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = e.target;
      if (!formTouched) setFormTouched(true);
      validateField('Acknowledge', checked ? 'true' : '')
      setFormDetails((prevData) => ({ ...prevData, Acknowledge: checked ? 'true' : '' }));
    };

    const clickAbleRowItems = (data: any, items: any) => {
      return (
        <button
          onClick={() => {
            handleRowItemClick(data);
          }}
        >
          {items}
        </button>
      );
    };

    const handleRowItemClick = (data: any) => {

      const selectedData = {
        City: data.City,
        AddressLine1: data.AddressLine1,
        AddressLine2: data.AddressLine2,
        ZipCode: data.PostalCode,
        State: data.Province,
      };
      setFormDetails((prevData) => ({ ...prevData, ...selectedData }));
      setOpen(false);
    };

    const validateAddress = async () => {
      try {
        //setLoaderBtn(true)
        dispatch(setLoading(true));
        setDisableValidate(true);
        let payload = {
          country: formDetails.countryId[0],
          phZipcode: formDetails.ZipCode,
          phState: formDetails.State,
          phCity: formDetails.City,
          addressline1: formDetails.AddressLine1,
        };

        try {
          const getAddress: any = await apiPost(POST_validateaddress, payload);
          //setLoaderBtn(false);
          dispatch(setLoading(false));
          if (getAddress.data) {
            let addresonchange = JSON.parse(getAddress.data.AddressDoctorResult);
            let newAdd = addresonchange.map((items: any) => ({
              ...items,
              AddressLine1: items.AddressLine1,
              AddressLine2: items.AddressLine2,
              City: items.City,
              State: items.Province,
              ZipCode: items.PostalCode,
              Country: items.Country,
              // AddressLine1: clickAbleRowItems(items, items.AddressLine1),
              // AddressLine2: clickAbleRowItems(items, items.AddressLine2),
              // Country: clickAbleRowItems(items, items.Country),
              // PostalCode: clickAbleRowItems(items, items.PostalCode),
              // City: clickAbleRowItems(items, items.City),
            }));
            setModalAddress(newAdd);
            setOpen(true);
            setIsValidateAddressClicked(true);
            setIsAddressValidated(true);
            setDisableValidate(true);
            setFormDetails((prevData) => ({ ...prevData,  ['validatedAddress']: "off" }));
            // setErrors((prevState) => ({ ...prevState, validateBtn: "" }));
          }
        } catch (error) {
          //setLoaderBtn(false);
          dispatch(setLoading(false));
          setDisableValidate(false);
          console.log("Error", error);
        }
      } catch (error) {
        toast.error(`${error}`);

        return false;
      }
    };
    
    return (
      <>

        <Card
          className="card-contact-containerr p-4"
          // background="filled"
          content={
            <form>
               {headerTitle ? (<div className="">
                  <h4>{headerTitle}</h4>
                  <h5>{headerContent}</h5>
                  {/* <p className="label-small" id="RequiredFields">
                        Required Fields <span className="text-danger">*</span>{" "}
                    </p> */}
                </div>
              ) : (
                ""
              )}
              <Row className="">

                 {<Col md={6}>
                    <Select
                      options={filteredAltContacts || []}
                                         label={`${t("HPI.CreateCase.Contactinformation.savedContact", { defaultValue: 'Saved Contact' })}${t("HPI.CreateCase.Contactinformation.choosefromlist", { defaultValue: 'Choose a saved contact or create a new contact' })}`}
                      helperTextVisibility="auto"
                      separateLabel
                      name="UserId"
                      onChange={(selectedOption: any) =>
                        onSelectChangeHandler(selectedOption, "UserId")
                      }
                      value={formDetails?.UserId}
                      placeholder={t("HPI.Dropdown.DefaultText", {
                        defaultValue: "Please select",
                      })}
                      onClear={() => {
                        selectSavedClearHandler();
                      }}
                      {...getFieldError(errors, "UserId")}
                      className="textbox"
                    />
                  </Col>
                }
              </Row>
              <Row>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t(
                      "HPI.CreateCase.address.Equipmentcontactfname",
                      { defaultValue: "Equipment Contact First Name" }
                    )}
                    required
                    name="FirstName"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterEquipmentContactFirstName",
                      { defaultValue: "Enter equipment contact first name" }
                    )}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    value={formDetails.FirstName}
                    error={!!errors.FirstName}
                    helperText={errors.FirstName}
                    className="textbox"
                  />
                </Col>

                <Col md={6}>
                  <TextBox
                    separateLabel
                     label={t(
                      "HPI.CreateCase.address.Equipmentcontactlname",
                      { defaultValue: "Equipment Contact Last Name" }
                    )}
                    required
                    name="LastName"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterEquipmentContactLastName",
                      { defaultValue: "Enter equipment contact last name" }
                    )}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    value={formDetails.LastName}
                    error={!!errors.LastName}
                    helperText={errors.LastName}
                    className="textbox"
                  />
                </Col>
              </Row>


              <Row>
                {/* <Col md={6}>
                  <Select
                    options={filteredCountryList}
                    showSearch
                    label={t("HPI.CreateCase.address.CountryRegion", {
                      defaultValue: "Country/Region",
                    })}
                    helperTextVisibility="auto"
                    separateLabel
                    name="countryId"
                    required
                    placeholder={t("HPI.ProfilePage.cs.SelectCountry", {
                      defaultValue: "Select country/Region",
                    })}
                    onClear={() => {
                      clearSelectHandler("countryId");
                    }}
                    value={formDetails?.countryId}
                    onSearch={(value: any) => {
                     let filtered: any = onSearchDropDown(
                        countryList,
                        value
                      );
                      setFilteredCountryList(filtered);
                    }}
                    onChange={(selectedOption: any) =>
                      onSelectChangeHandler(selectedOption, "countryId")
                    }
                    {...getFieldError(errors, "countryId")}
                    className="textbox"
                  />
                </Col> */}

                <Col md={6}>
                  <TextBox
                    value={formDetails.Extension}
                    label={t(
                      "HPI.CreateCase.Contactinformation.Extension",
                      { defaultValue: "Extension" }
                    )}
                    name="Extension"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterExtension",
                      { defaultValue: "Enter extension" }
                    )}
                    separateLabel
                    className="textbox"
                    onChange={(v: any, e) => {
                      const value = getValidatedNumberInput(v, 5);
                      if (value.length <= 5) {
                        handleInputChange(value, e);
                      }
                    }}
                  />
                </Col>
              </Row>


              <Row>
                <Col md={6} lg={2}>

                  <Select
                    separateLabel
                    options={filteredCountryCodes}
                    showSearch
                    name="contactCountryId"
                    label={t("HPI.ProfilePage.cs.SelectCountryCode", {
                      defaultValue: "Code",
                    })}
                    placement="bottom"
                    placeholder={t("HPI.ProfilePage.cs.SelectCountryCode", {
                      defaultValue: "Code",
                    })}
                    value={formDetails.contactCountryId}
                    required
                    helperTextVisibility="auto"
                    onClear={() => {
                      clearSelectHandler("contactCountryId");
                    }}
                    onSearch={(value: any) => {
                     let filtered: any = onSearchDropDown(
                        countryCodes,
                        value
                      );
                      setFilteredCountryCodes(filtered);
                    }}
                    onChange={(selectedOption: any) =>
                      onSelectChangeHandler(selectedOption, "contactCountryId")
                    }
                    {...getFieldError(errors, "contactCountryId")}
                    className="textbox country-code"
                  />


                </Col>
                <Col md={6} lg={4}>
                  <label>
                    {t("HPI.CreateCase.Contactinformation.Phonenumber", {
                      defaultValue: "Phone Number",
                    })}
                  </label>
                  <span className="error">*</span>
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={isOpen}
                    onClose={() => setIsOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.Contactinformation.Phonenumber", {
                          defaultValue: "Phone Number",
                        })
                      )
                    }
                  >
                    <p>
                      {t("HPI.Profilepage.PhoneNumberToolTip.body", {
                        defaultValue:
                          "Please enter no more than 15 numerals, starting with country code (do not use " +
                          " or any other characters)",
                      })}
                    </p>
                  </HelpModalPopup>
                  <TextBox
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterPhoneNumber",
                      { defaultValue: "Enter phone number" }
                    )}
                    required
                    value={formDetails.PhoneNumber}
                    name="PhoneNumber"
                    onChange={(v: any, e) => {
                      const value = getValidatedNumberInput(v, 15);
                      if (value.length <= 15) {
                        handleInputChange(value, e);
                      }
                    }}
                    onBlur={(e) => handleBlur(e)}
                    error={!!errors.PhoneNumber}
                    helperText={errors.PhoneNumber}
                    className="textbox"
                  />

                </Col>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.Contactinformation.Email", {
                      defaultValue: "Email",
                    })}
                    type="email"
                    name="Email"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterEmail",
                      { defaultValue: "Enter email" }
                    )}
                    value={formDetails.Email}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    onBlur={(e) => handleBlur(e)}
                    error={!!errors.Email}
                    helperText={errors.Email}
                    className="textbox"
                  />
                </Col>
              </Row>
            </form>
          }
        />
        <Card
          className="card-contact-containerr p-4"
          background="filled"
          content={
            <form>
              {headerTitle2 ? (
                <div className="">
                  <h4>{headerTitle2}</h4>
                </div>
              ) : (
                ""
              )}
              {!window.IsIndividualRole && (
                <Row>
                  <Col md={6}>
                    <Select
                      options={siteNameList}
                      showSearch
                      label={t("HPI.CreateCase.CompanyName", {
                        defaultValue: "Site-Name",
                      })}
                      helperTextVisibility="auto"
                      separateLabel
                      name="SiteName"
                      value={formDetails?.SiteName}
                      placeholder={t("HPI.Dropdown.DefaultText", {
                        defaultValue: "Please select",
                      })}
                      onSearch={(value: any) => {
                        let filtered: any = onSearchDropDown(
                          siteSubAccount,
                          value
                        );
                        setSiteNameList(filtered);
                      }}
                      onChange={(selectedOption: any) => {
                        onSelectChangeHandler(selectedOption, "SiteName");
                        onSiteChangeHandler(selectedOption);
                      }}
                      onClear={() => {
                        onSiteNameCleareHandler();
                      }}
                      {...getFieldError(errors, "SiteName")}
                      className="textbox"
                    />
                  </Col>

                  <Col md={6}>
                    {formDetails?.SiteName.length > 0 &&
                    formDetails?.SiteName?.[0] !== "" &&
                    bindPin.length > 0 ? (
                      <Select
                        options={bindPinList}
                        showSearch
                        label={t("HPI.CreateCase.Pin", {
                          defaultValue: "Pin",
                        })}
                        helperTextVisibility="auto"
                        disabled={!formDetails.BindingPin}
                        separateLabel
                        name="BindingPin"
                        placeholder={t("HPI.PIN", {
                          defaultValue: "Select Pin",
                        })}
                        required
                        onSearch={(value: any) => {
                          let filtered: any = onSearchDropDown(
                            bindPin,
                            value
                          );
                          setBindPinList(filtered);
                        }}
                        value={formDetails?.BindingPin}
                        onChange={(selectedOption: any) =>
                          onSelectChangeHandler(
                            selectedOption,
                            "BindingPin"
                          )
                        }
                        // onClear={() => {selectPinClearHandler()}}
                        clearIcon={false}
                        {...getFieldError(errors, "BindingPin")}
                        className="textbox"
                      />
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              )}
              <Row>
                {!window.IsIndividualRole && (
                  <Col md={6}>
                    <TextBox
                      separateLabel
                      label={t("HPI.CreateCase.address.Company", {
                        defaultValue: "Company",
                      })}
                      type="text"
                      name="company"
                      required
                      placeholder={t(
                        "HPI.CreateCase.Placeholder.EnterCompany",
                        { defaultValue: "Enter company" }
                      )}
                      value={formDetails.company}
                      onChange={(v: any, e) => handleInputChange(v, e)}
                      error={!!errors.company}
                      helperText={errors.company}
                      className="textbox"
                    />
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.AddressLine1", {
                      defaultValue: "Address Line 1",
                    })}
                    type="text"
                    name="AddressLine1"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterAddressLine1",
                      { defaultValue: "Enter address line 1" }
                    )}
                    className="textbox"
                    value={formDetails.AddressLine1}
                    error={!!errors.AddressLine1}
                    helperText={errors.AddressLine1}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                  />
                </Col>

                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.AddressLine2", {
                      defaultValue: "Address Line 2",
                    })}
                    type="text"
                    name="AddressLine2"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterAddressLine2",
                      { defaultValue: "Enter address line 2" }
                    )}
                    className="textbox"
                    value={formDetails.AddressLine2}
                    //error={!!errors.AddressLine2}
                    //helperText={errors.AddressLine2}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.Mailstop", {
                      defaultValue: "Mail Stop",
                    })}
                    type="text"
                    name="Mailstop"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterMailStop",
                      { defaultValue: "Enter mail stop" }
                    )}
                    value={formDetails.Mailstop}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    className="textbox"
                  />
                </Col>

                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.City/Town", {
                      defaultValue: "City/Town",
                    })}
                    type="text"
                    name="City"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterCity/Town",
                      { defaultValue: "Enter city/town" }
                    )}
                    value={formDetails.City}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.City}
                    helperText={errors.City}
                    className="textbox"
                  />
                </Col>
              </Row>
              <Row>


                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.State/Province", {
                      defaultValue: "State/Province",
                    })}
                    type="text"
                    name="State"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterState/Province",
                      { defaultValue: "Enter state/province" }
                    )}
                    value={formDetails.State}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.State}
                    helperText={errors.State}
                    className="textbox"
                  />
                </Col>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.ZipCode", {
                      defaultValue: "Zip code and Postal code",
                    })}
                    type="text"
                    name="ZipCode"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterZipCode/postalCode",
                      { defaultValue: "Enter zip code/postal code" }
                    )}
                    value={formDetails.ZipCode}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.ZipCode}
                    helperText={errors.ZipCode}
                    className="textbox"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Select
                    options={filteredCountryList}
                    showSearch
                    label={t("HPI.CreateCase.address.CountryRegion", {
                      defaultValue: "Country/Region",
                    })}
                    helperTextVisibility="auto"
                    separateLabel
                    name="countryId"
                    required
                    placeholder={t("HPI.ProfilePage.cs.SelectCountry", {
                      defaultValue: "Select country/Region",
                    })}
                    onClear={() => {
                      clearSelectHandler("countryId");
                    }}
                    value={formDetails?.countryId}
                    onSearch={(value: any) => {
                     let filtered: any = onSearchDropDown(
                        countryList,
                        value
                      );
                      setFilteredCountryList(filtered);
                    }}
                    onChange={(selectedOption: any) =>
                      onSelectChangeHandler(selectedOption, "countryId")
                    }
                    {...getFieldError(errors, "countryId")}
                    className="textbox"
                  />
                </Col>
              </Row>
              <Row>

                {IsTaxEnabledCountry.includes(formDetails?.countryId[0]) &&
                  formDetails?.showparts === "100000000" && (
                    <Col md={6}>
                      <TextBox
                        separateLabel
                        label={t("HPI.CreateCase.TaxId", {
                          defaultValue: "Tax Id",
                        })}
                        required
                        type="text"
                        name="equipmentTaxId"
                        placeholder={t(
                          "HPI.CreateCase.Placeholder.EnterTaxId",
                          { defaultValue: "Enter tax Id" }
                        )}
                        value={formDetails.equipmentTaxId}
                        onChange={(v: any, e) => handleInputChange(v, e)}
                        error={!!errors.equipmentTaxId}
                        helperText={errors.equipmentTaxId}
                        className="textbox"
                      />
                    </Col>
                  )}
              </Row>
              {IsTaxEnabledCountry.includes(formDetails?.countryId[0]) &&
                formDetails?.showparts === "100000000" && (
                  <Row>
                    <Col md={6}>
                      <TextBox
                        separateLabel
                        label={t("HPI.CreateCase.TaxOfficeNames", {
                          defaultValue: "Tax Office Names",
                        })}
                        required
                        type="text"
                        name="equipmentTaxOfficeName"
                        placeholder={t(
                          "HPI.CreateCase.Placeholder.EnterTaxOfficeNames",
                          { defaultValue: "Enter tax office names" }
                        )}
                        value={formDetails.equipmentTaxOfficeName}
                        onChange={(v: any, e) => handleInputChange(v, e)}
                        error={!!errors.equipmentTaxOfficeName}
                        helperText={errors.equipmentTaxOfficeName}
                        className="textbox"
                      />
                    </Col>
                  </Row>
                )}
              {/* <Row>
                <Col md={12} className="checkbox-container">
                  <div>
                    <Checkbox
                      name="Acknowledge"
                      onChange={onAcknowledgeHandler}
                      label={checkBoxContent}
                      checked={formDetails.Acknowledge === "true"}
                    />
                    {!!errors.Acknowledge && (
                      <label className="error-text" id="checklabel">
                        {" "}
                        {t("HPI.OpenContactCreate.Checkboxpheading", {
                          defaultValue: "You need to acknowledge text above",
                        })}{" "}
                      </label>
                    )}
                  </div>
                </Col>
              </Row> */}

              <Row>
                <Col>
                  {contryEnable && (
                    <div className="row">
                      <div className="d-flex justify-content-start mt-4">
                        <Button
                          id="btn-submit"
                          disabled={disableValidate}
                          onClick={() => { setIsValidateAddressClicked(true); validateAddress() }}
                          type="button"
                          name="validateBtn"
                          className="btn btn-submit"
                        >
                          {/* {loaderBtn ? (
                            <div className="loader-overlay">
                              <div className="loader-css">
                                <Loader />
                              </div>
                            </div>
                          ) : (
                            t("HPI.ValidateAddress", { defaultValue: "Validate Address" }) // Button text when not loading
                          )} */}
                          {t("HPI.ValidateAddress", {
                            defaultValue: "Validate Address",
                          })}
                        </Button>
                      </div>
                      <div>
                      {contryEnable && showValidateWarning && (
                        <InlineNotification
                          actionPlacement="top"
                          closeButton={false}
                          customStyle={{
                            width: "40%",
                            marginTop: "10px"
                          }}
                          description={t("HPI.ValidateAddress.error", {
                            defaultValue: "Please click on validate address button before case submission.",
                            }
                          )}
                          type="negative"
                        />
                      )}
                      </div>
                    </div>
                  )}
                  <Modal
                    className="validate-address-modal"
                    id="modal-id"
                    show={open}
                    header={
                      <div className="popup-header" style={{ display: "flex" }}>
                        <HpLogo />
                        <h3 className="mt-4"> {t("HPI.Profilepage.myprofile.Address", { defaultValue: 'Address' })}</h3>
                      </div>
                    }
                  >
                    <div style={{ maxHeight: '900px', overflowY: 'auto' }}>
                      {pagedData.length > 0 ? (
                        <CustomTable
                          key={currentPage}
                          columns={columns}
                          data={pagedData}
                          onRowSelect={handleAddressRowSelect}
                        />
                      ) : (
                        <div className="text-center py-4">
                          <h3>No records found</h3>
                        </div>
                      )}
                      {modalAddress.length > PAGE_SIZE && (
                    <div className="d-flex justify-content-end mt-3 gap-2">
                      <Button
                         appearance="secondary"
                         disabled={currentPage === 1}
                         onClick={() => handlePageChange('prev')}>Prev </Button>
                                          
                       <Button
                        appearance="secondary"
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange('next')} >Next </Button>
                    </div>
                      )}
                    </div>

                    <div className="mt-4 d-flex align-items-center gap-3">
                      <Button
                        id="btn-cancel"
                        appearance="secondary"
                        onClick={handleRetainClicked}
                      >Retain existing</Button>
                      <Button
                        appearance="primary"
                        disabled={!isRowSelected || modalAddress.length === 0}
                        onClick={handleAcceptAddress}
                      >
                        Accept
                      </Button>
                    </div>
                  </Modal>
                </Col>
              </Row>
            </form>
          }
        />
      </>
    );
  });

export default PhysicalAddressFields;